var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth"
  }, [_c('VerticalStepList', _vm._b({
    attrs: {
      "id": "steps"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var step = _ref.step;
        return [_c(step.component, {
          ref: "".concat(step.key, "Step"),
          tag: "component",
          staticClass: "step",
          attrs: {
            "resendTimer": _vm.resendTimer
          },
          on: {
            "resendSms": _vm.resendSms,
            "startTimer": _vm.startResendCountdown
          }
        })];
      }
    }])
  }, 'VerticalStepList', {
    stepList: _vm.authStepComponentList
  }, false)), !_vm.isMobile ? _c('Footer') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }